import axiosInstance from "@/boot/axios";

class OptionsRepository {
    constructor() {
        this.path = "/v1/options";
    }

    async getByType(type, status, withStatus = true) {
        const response = await axiosInstance.get(
            `${this.path}?type=${type}&status=${status.join(",")}&includeStatus=${withStatus}`,
            {},
        );
        return response.data;
    }

    async createGroup(type, payload) {
        const response = await axiosInstance.post(`${this.path}?type=${type}`, payload);
        return response.data;
    }

    async updateGroup(id, payload) {
        const response = await axiosInstance.put(`${this.path}/${id}`, payload);
        return response.data;
    }

    async createGroupItem(id, payload) {
        const response = await axiosInstance.post(`${this.path}/${id}/item`, payload);
        return response.data;
    }

    async updateGroupItem(groupId, itemId, payload) {
        const response = await axiosInstance.put(`${this.path}/${groupId}/item/${itemId}`, payload);
        return response.data;
    }
}

export default new OptionsRepository();
